import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import profileimgs from "../../assets/images/profile.png";
import bellicon from "../../assets/images/bellicon.svg"
import { NavLink, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, selectAuth, setLeadPageRefresh } from "../../redux/slice/authSlice";
import { logout, setNotificatioId } from "../../redux/slice/authSlice";
import { useNavigate } from "react-router-dom";
import useEncryption from "../../services/useEncryption";
import path from "../../path";
import io from "socket.io-client";
import { getAllNotificationApi, markAllReadNotificationApi, updateNotificationApi } from "../../api/userApi/userApi";
import {  IconButton, Typography, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


function Header({ pageTitle }) {
  const { encryptData, decryptData } = useEncryption();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEn, setAnchorEn] = React.useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  // const opens = Boolean(anchorEn);
  const [opens, setOpens] = useState(false);
  const { id, userRole } = useParams();
  const { userProfile, role, refresh } = useSelector(selectAuth); 
  const decryptProfile = decryptData(userProfile);
  const [ notification, setNotification ] = React.useState([]);
  const [ count, setCount ] = React.useState(0);
  const anchorRef = useRef(null);
  const viewAllRef = useRef(null); 
  const profileMenuRef = useRef(null); 


  const encryptedId = encodeURIComponent(decodeURIComponent(id));
  const decryptedId = decryptData(decodeURIComponent(id));


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleClickNoti = () => {
    setOpens((prev) => !prev); // Toggle open state on button click
  };

  const handleClosed = async(result) => {
    let data = await updateNotificationApi(result._id);
    dispatch(setNotificatioId(result.leadId));
    dispatch(setLeadPageRefresh(!refresh)); 
    // console.log(data)
    getNotificationList();
    setAnchorEn(null);
    navigate(`/${role}/${encryptedId}`);
  };

  const handleSignOut = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("expiryTime");
    dispatch(logout());
    navigate("/");
  };

  const getNotificationList = async() =>{
    try {
      let response = await getAllNotificationApi(role);
      let decrypt = decryptData(response.data.data.notifiData);
      setNotification(decrypt);
      setCount(response.data.data.countNote);
    } catch (error) {
      console.log(error);
      setNotification([]);
    }
  }

  const markAllReadNotification = async() =>{
    try {
      let response = await markAllReadNotificationApi(role);
      getNotificationList();
    } catch (error) {
      console.log(error);
      setNotification([]);
    }
  }

  useEffect(() => {
    if (decryptedId) {
      dispatch(getProfile(decryptedId)); 
    }

    // Connect to the socket server
    const socket = io(path,{
      withCredentials : true
    });

    socket.on("userDeleted", (data) => {
      if(decryptedId === data._id){
        handleSignOut();
      }
    });

    socket.on("notification_created", (data) => {
      getNotificationList();
    });

    getNotificationList();
    return () => {
      socket.disconnect();
    };

  }, [dispatch, decryptedId]);
 
  const handleToggleBodyClass = () => {
    document.body.classList.toggle('sidebarOpen');
  };

 

  const handleClose = (e) => {
    setAnchorEl(null)
    if (
      (anchorRef.current && anchorRef.current.contains(e.target)) ||
      (viewAllRef.current && viewAllRef.current.contains(e.target))
    ) {
      return;
    }
    setOpens(false);
  };

  const handleViewAll = () => {
    navigate(`/${userRole}/notificaton/${encryptedId}`);
  };

  const handleCloseProfile = (e) => {
    if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
      setAnchorEl(null);
    }
  };

  //  useEffect(() => {
  //   if (opens) {
  //     document.addEventListener('mousedown', handleClose);
  //   } else {
  //     document.removeEventListener('mousedown', handleClose);
  //   }
  //   return () => document.removeEventListener('mousedown', handleClose);
  // }, [opens]);


  useEffect(() => {
    if (opens) {
      document.addEventListener('mousedown', handleClose);
    } else {
      document.removeEventListener('mousedown', handleClose);
    }

    if (open) {
      document.addEventListener('mousedown', handleCloseProfile);
    } else {
      document.removeEventListener('mousedown', handleCloseProfile);
    }

    return () => {
      document.removeEventListener('mousedown', handleClose);
      document.removeEventListener('mousedown', handleCloseProfile);
    };
  }, [opens, open]);
  


  return (
    <header className="mainheader">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
        <div className="onlymobile">
         
          <button className="toggleicon" onClick={handleToggleBodyClass}>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
              <mask id="mask0_557_4257" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="60">
                <rect width="60" height="60" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_557_4257)">
                <path d="M10 45C9.29167 45 8.69792 44.7604 8.21875 44.2813C7.73958 43.8021 7.5 43.2083 7.5 42.5C7.5 41.7917 7.73958 41.1979 8.21875 40.7188C8.69792 40.2396 9.29167 40 10 40H50C50.7083 40 51.3021 40.2396 51.7812 40.7188C52.2604 41.1979 52.5 41.7917 52.5 42.5C52.5 43.2083 52.2604 43.8021 51.7812 44.2813C51.3021 44.7604 50.7083 45 50 45H10ZM10 32.5C9.29167 32.5 8.69792 32.2604 8.21875 31.7813C7.73958 31.3021 7.5 30.7083 7.5 30C7.5 29.2917 7.73958 28.6979 8.21875 28.2187C8.69792 27.7396 9.29167 27.5 10 27.5H50C50.7083 27.5 51.3021 27.7396 51.7812 28.2187C52.2604 28.6979 52.5 29.2917 52.5 30C52.5 30.7083 52.2604 31.3021 51.7812 31.7813C51.3021 32.2604 50.7083 32.5 50 32.5H10ZM10 20C9.29167 20 8.69792 19.7604 8.21875 19.2812C7.73958 18.8021 7.5 18.2083 7.5 17.5C7.5 16.7917 7.73958 16.1979 8.21875 15.7187C8.69792 15.2396 9.29167 15 10 15H50C50.7083 15 51.3021 15.2396 51.7812 15.7187C52.2604 16.1979 52.5 16.7917 52.5 17.5C52.5 18.2083 52.2604 18.8021 51.7812 19.2812C51.3021 19.7604 50.7083 20 50 20H10Z" fill="#1C1B1F" />
              </g>
            </svg>
          </button>
        </div>
        <div className="mainTitleofPage">{pageTitle}</div></div>
        <div>
          <Button className="notificationbtn"
            id="basic-button"
            aria-controls={opens ? 'basic-menu-noti' : undefined}
            aria-haspopup="true"
            aria-expanded={opens ? 'true' : undefined}
            onClick={handleClickNoti}
            ref={anchorRef}
          >
            <div className="notificationblock">
              <img src={bellicon} alt="notifcationicon" />
              {count > 0 && <div className="badegIcon">{count}</div>}
            </div>

          </Button>
          <Menu
            id="basic-menu-noti"
            anchorEl={anchorRef.current}
            open={opens}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {/* Notification Header with Close Icon */}
            <div style={styles.menuHeader}>
              <Typography variant="body1" fontWeight="bold">
                Notifications
              </Typography>
              <IconButton onClick={handleClose} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
            
            {/* Divider */}
            <Divider />

            {/* Notifications List */}
            <MenuItem style={styles.linkText} onClick={markAllReadNotification}>Mark all as read</MenuItem>
            {
              notification.map((result, index) => (
                <MenuItem
                  className="notificationdeatils"
                  onClick={() => handleClosed(result)}
                  key={index}
                  style={!result.rolesNotified[role]?.isRead ? styles.unreadNotification : {}}
                >
                  {result.content}
                </MenuItem>
              ))
            }

            {/* View All */}
            <MenuItem style={styles.viewAllLink} onClick={handleViewAll} ref={viewAllRef}>
              View All
            </MenuItem>
          </Menu>
          <Button className="avtarbutton"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <div className="profileicon">
              <img 
                src={ decryptProfile?.photo ? `${path}/${decryptProfile?.photo.split("/").pop()}` : profileimgs}
                alt="profileimgs" 
                onError={(e) => e.target.src = profileimgs}
              />
            </div>

          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            ref={profileMenuRef}
          >
            {decryptProfile?.firstName && decryptProfile?.lastName && (
              <MenuItem disabled>
                <div style={styles.userName}>
                  {decryptProfile.firstName} {decryptProfile.lastName}
                </div>
              </MenuItem>
            )}
            <MenuItem onClick={handleClose}><NavLink className="dropdownmenused" to={`/${userRole}/profile/${encryptedId}`}>My Profile</NavLink></MenuItem>
            {/* <MenuItem onClick={handleClose}><NavLink className="dropdownmenused" to='/doctor/dashboard/255636/locationprofile'>Location Profile</NavLink></MenuItem> */}
            <MenuItem onClick={handleSignOut}><NavLink className="dropdownmenused"  >Logout</NavLink></MenuItem>
          </Menu>
        </div>

      </div>


    </header>
  );
}

const styles = {
  avatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#3f51b5',
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  userName: {
    padding: '10px 0',
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
  },
  menuHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
    borderBottom: '1px solid #ddd',
  },
  linkText: {
    color: '#000', // Color for clickable links
    cursor: 'pointer',
    fontSize: '12px',
    textDecoration: 'underline',
    fontWeight: 'bold',
    marginBottom : '8px'
  },
  viewAllLink: {
    display: 'flex',         // Flexbox to align content
    justifyContent: 'flex-end',  // Pushes content to the right
    fontSize: '13px',         // Smaller font size
    color: '#000',         // Optional color
    textDecoration: 'underline',
    cursor: 'pointer',        // Pointer cursor on hover
    width: '100%',
    marginTop : '8px'  
  },
  unreadNotification: {
    backgroundColor: '#f0f0f0', // Light gray for unread notifications
    padding: '10px 16px', // Add padding to make it look like a box
    borderRadius: '4px', // Optional: add rounded corners
    marginBottom: '8px', // Optional: add space between notifications
    border: '1px solid #ddd'
  },
};


export default Header;










